import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Endpoints } from '@huge-monorepo/portal/config';

export class LocalPreferences {
  public preferedGraphUnit = 'MB';
}
@Injectable({
  providedIn: 'root',
})
export class MemoryService {
  private storage = window.localStorage;
  private localPreferences;
  constructor(private endpoints: Endpoints) {
    const prefs = this.getLocalPreferencesStorage();
    if (prefs != null) {
      this.localPreferences = new BehaviorSubject<LocalPreferences>(prefs);
    } else {
      this.localPreferences = new BehaviorSubject<LocalPreferences>(new LocalPreferences());
    }
  }

  setDetails(isCdr: boolean, orderBy: string, search: string, tableCount: number, tableOffset: number, desc: boolean) {
    const obj = {
      isCdr: isCdr,
      orderBy: orderBy,
      search: search,
      tableCount: tableCount,
      tableOffset: tableOffset,
      desc: desc,
    };
    this.storage.setItem(this.endpoints.DEVICE_DETAILS_KEY, JSON.stringify(obj));
  }

  getDetails() {
    return JSON.parse(this.storage.getItem(this.endpoints.DEVICE_DETAILS_KEY));
  }

  removeDetails() {
    this.storage.removeItem(this.endpoints.DEVICE_DETAILS_KEY);
  }

  getLocalPreferences(): BehaviorSubject<LocalPreferences> {
    return this.localPreferences;
  }

  private getLocalPreferencesStorage(): LocalPreferences {
    const prefs = this.storage.getItem('local_preferences');
    if (prefs != null) {
      return JSON.parse(prefs) as LocalPreferences;
    }
    return null;
  }

  private setLocalPreferences(prefs: LocalPreferences): void {
    this.storage.setItem('local_preferences', JSON.stringify(prefs));
  }

  setPreferedGraphUnit(unit: string) {
    const current = this.localPreferences.value;
    current.preferedGraphUnit = unit;
    this.localPreferences.next(current);
    this.setLocalPreferences(current);
  }
}
